import styled from 'styled-components'
import { device } from '../responsive'
import { AiFillGithub, AiFillLinkedin } from 'react-icons/ai'


export const Container = styled.div`
    max-width: 1200px;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    padding: 90px 30px;

    @media screen and ${device.mobile} {
        
        padding: 70px 20px;
    }
`
export const Left = styled.div`
    flex: 1 0 400px;
    text-align: left;
    margin-left: 20px;
    @media screen and ${device.laptop} {
        text-align: center;
        margin-right: 0px;
        margin-bottom: 40px;
        margin-left: 0px;
    }

    @media screen and ${device.tablet} {
        flex-basis: 400px;
    }

    @media screen and ${device.mobile} {
        flex-basis: 300px;
        margin-bottom: 60px;
    }
`
export const Right = styled.div`
   max-width: 600px;
   
`
export const Image = styled.img`
  width: 100%;
  object-fit: cover;
`

export const TopTitle = styled.div`
    font-size: 21px;
    font-weight: 500;
    margin-bottom: 10px;
    margin-top: 0px;
    text-transform: uppercase;  

    @media screen and ${device.mobile} {
        font-size: 20px;
    }
    @media screen and ${device.xsmobile} {
        font-size: 18px;
    }
`

export const Title = styled.h1`
    font-size: 70px;
    font-weight: 600;
    margin-bottom: 1rem;
    letter-spacing: 2px;
    color: #2F2E41;
    margin-top: 0.2rem;
    

    @media screen and ${device.tablet} {
        font-size: 45px;
    }

    @media screen and ${device.mobile} {
        font-size: 2.7rem;
    }
    @media screen and ${device.xsmobile} {
        font-size: 2.1rem;
    }


`
export const Text = styled.p`
    font-size: 22px;
    font-weight: 400;
    margin-top: 0px;
    line-height: 35px;
    color: #2F2E41;
    width: 80%;

    @media screen and ${device.laptop} {
        margin: auto;
        font-size: 20px;
    }
    @media screen and ${device.tablet} {
        font-size: 17px;
        line-height: 28px;
    }
    @media screen and ${device.xsmobile} {
        font-size: 16px;
    }
`
export const Buttons = styled.div`
    display: flex;
    padding-top: 15px;
    

    @media screen and ${device.laptop} {
        justify-content: center;
        margin-top: 20px;
    }

    @media screen and ${device.mobile} {
        padding-top: 10px;
    }
`
export const LinkedinBtn = styled.a`
    transition: all 0.3s ease-in-out;
    cursor: pointer; 
    font-size: 1rem;
    margin-right: 10px;
    text-decoration: none;
    padding: 13px 20px;
    border-radius: 15px;
    background-color: #008080;
    color: #ffffff;  
    display: flex;
    align-items: center;
    width: 110px;
    justify-content: center;

    &:hover {
        background-color: #5BA5A5;
        
    }
    

    @media screen and ${device.mobile} {
        padding: 8px 15px;
        font-size: 0.9rem;
        margin-right: 10px;
    }  
    
`

export const GithubBtn = styled.a`
    transition: all 0.3s ease-in-out;
    cursor: pointer; 
    font-size: 1rem;
    margin-right: 20px;
    text-decoration: none;
    padding: 13px 20px;
    
    color: #fffffe;
    border-radius: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #2F2E41;
    width: 110px;

     
    &:hover {
        background-color: #49485F;
    }

    @media screen and ${device.mobile} {
        padding: 8px 15px;
        font-size: 0.9rem;
        margin-right: 0px;
        
    }
`

export const Icon = styled.p`
    font-weight: 600;
    margin: 0;
`

export const GitLink = styled(AiFillGithub)`
    color: #fffffe;
    font-size: 1.4rem;
    margin-right: 10px;
    
`
export const LinkedLink = styled(AiFillLinkedin)`
    color: #ffffff;
    font-size: 1.4rem;
    margin-right: 10px;

`

export const Color = styled.span`
    color: #008080;
`